// @flow
import React, { Component } from "react";
import HelpersOverlay from "./HelpersOverlay";
import DrawCircle from "./DrawCircle";
import DrawLine from "./DrawLine";
import type { Point } from "../Types";
import utils from "../utils";

/** Precision visual helpers */

/**
 * Precision mode visual helpers
 */
type KnobVisualHelpersProps = {
  svgRef: any,
  radius: number,
  minimumDragDistance: number,
  valueAngle: number,
  mousePos: Point,
  lineColor: string,
};

type KnobVisualHelpersState = {
  centerX: number,
  centerY: number,
  valueMarkerX: number,
  valueMarkerY: number,
  mouseMarkerX: number,
  mouseMarkerY: number,
};

class KnobVisualHelpers extends React.Component<
  KnobVisualHelpersProps,
  KnobVisualHelpersState
> {
  state = {
    centerX: 0,
    centerY: 0,
    valueMarkerX: 0,
    valueMarkerY: 0,
    mouseMarkerX: 0,
    mouseMarkerY: 0,
  };

  static getDerivedStateFromProps(
    props: KnobVisualHelpersProps,
    state: KnobVisualHelpersState
  ) {
    //Calculate position
    const vbox = props.svgRef.getBoundingClientRect();
    const halfWidth = vbox.width / 2;
    const halfHeight = vbox.height / 2;

    //Calculate current angle segment end point
    //Note: Not sure why we need to substract 90 here
    const valueMarkerX =
      props.radius * Math.cos(utils.toRadians(props.valueAngle - 90));
    const valueMarkerY =
      props.radius * Math.sin(utils.toRadians(props.valueAngle - 90));

    const distance = Math.sqrt((props.mousePos.x - (vbox.left + halfWidth))**2 + (props.mousePos.y - (vbox.top + halfHeight))**2)
    const mouseMarkerX =
      (vbox.left + halfWidth) + (props.mousePos.x - (vbox.left + halfWidth)) * (props.radius / distance);
    const mouseMarkerY =
      (vbox.top + halfHeight) + (props.mousePos.y - (vbox.top + halfHeight)) * (props.radius / distance);

    return {
      ...state,
      centerX: vbox.left + halfWidth,
      centerY: vbox.top + halfHeight,
      valueMarkerX,
      valueMarkerY,
      mouseMarkerX,
      mouseMarkerY,
    };
  }

  render() {
    const markCircleColor =
      this.props.minimumDragDistance <= this.props.radius ? "green" : "grey";
    const fillColor =
      this.props.minimumDragDistance <= this.props.radius
        ? "#88E22D"
        : "#D8D8D8";
    const minDistanceCueVisible =
      this.props.minimumDragDistance >= this.props.radius;

    return (
      <HelpersOverlay>
        <svg
          style={{ position: "absolute", top: "0", left: "0" }}
          width="100%"
          height="100%"
        >

          {/* Current drag distance */}
          <DrawCircle
            borderColor={markCircleColor}
            fillColor={fillColor}
            fillOpacity={0.02}
            r={this.props.radius}
            cx={this.state.centerX}
            cy={this.state.centerY}
          />
          {/* Minimum drag distance marker */}
          {minDistanceCueVisible && (
            <DrawCircle
              borderColor={markCircleColor}
              fillColor={fillColor}
              fillOpacity={0}
              r={this.props.minimumDragDistance}
              cx={this.state.centerX}
              cy={this.state.centerY}
              strokeDasharray="5, 5"
            />
          )}

          {/* Line to mouse position */}
          {
            this.props.mousePosition ? (
              <DrawLine
                p1={{ x: this.state.centerX, y: this.state.centerY }}
                p2={{
                  x: this.state.mouseMarkerX ,
                  y: this.state.mouseMarkerY ,
                }}
                color={this.props.lineColor}
                // opacity={0.4}
                // strokeDasharray="5, 5"
              />
            ) : (
              /* Line to current value */
              <DrawLine
                p1={{ x: this.state.centerX, y: this.state.centerY }}
                p2={{
                  x: this.state.valueMarkerX + this.state.centerX,
                  y: this.state.valueMarkerY + this.state.centerY,
                }}
                color={this.props.lineColor}
              />
            )
          }
        </svg>
      </HelpersOverlay>
    );
  }
}

export { KnobVisualHelpers };
